import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export type FaqSortableSectionRenderProps = {
  setNodeRef: (node: HTMLElement | null) => void;
  style: React.CSSProperties;
  dragHandleProps: Record<string, unknown>;
  isDragging: boolean;
};

type FaqSortableSectionProps = {
  id: string;
  disabled: boolean;
  children: (props: FaqSortableSectionRenderProps) => React.ReactNode;
};

export const FaqSortableSection: React.FC<FaqSortableSectionProps> = ({
  id,
  disabled,
  children,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled,
  });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: isDragging ? "grabbing" : undefined,
    ...(isDragging
      ? {
          position: "relative" as const,
          zIndex: 9999,
          willChange: "transform",
        }
      : {}),
  };

  const dragHandleProps = { ...attributes, ...listeners };

  return <>{children({ setNodeRef, style, dragHandleProps, isDragging })}</>;
};
